import Link from "next/link";
import React, { useContext, useState, useEffect, useTransition } from "react";
import helper from "../../lib/helper";
import collectionModel from "../../models/collections.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import AsyncSelect from "react-select/async";
import { Dropdown } from "react-bootstrap";
import moment from "moment/moment";

const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: collectionData, mutate: reloadCollectionData, isLoading } = useSWR(
        queryParams || null,
        async () => await collectionModel.list(queryParams),
        config.swrConfig
    );

    const [selectedValue, setSelectedValue] = useState('');


    const collectionStatus = function (id, status) {
        const formData = new FormData();
        formData.append('status', status);
        collectionModel.update(id, formData).then((res) => {
            const collection = _.find(collectionData?.data, { id: id });
            collection.status = status;
            reloadCollectionData()
        })
    }

    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedValue(selectedValue);

        const queryParams = new URLSearchParams(router.query);
        queryParams.set('status', selectedValue);

        router.push(`${router.pathname}?${queryParams.toString()}`);
    };
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const selectedValue = queryParams.get('selectedValue');

        // Use the selectedValue for further processing or data fetching

    }, []);


    const columns = [
        {
            Header: 'Image',
            className: 'col',
            id: 'image',
            Cell: ({ row }) => (
                <>  <img src={row.original.thumbnail} height="40px" width="50px" /> </>
            )
        },
        {
            Header: "Title",
            accessor: "title",
            className: "col"
        },
        {
            Header: "Status",
            accessor: "status",
            className: "col",

        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                        {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
        },

        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div >

                        <Dropdown className="btn-group btn-group-sm">
                            <Link
                                className="btn btn-outline-primary"
                                href={`/collections/${row.original.id}`}
                            >
                                <i className="bi bi-eye"></i>
                            </Link>
                            <Dropdown.Toggle size="sm" variant="outline-primary">
                                <i className="bi bi-three-dots-vertical"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    className="btn btn-warning"
                                    href={`/collections/${row.original.id}/edit`}
                                >
                                    <i className="bi bi-pencil-square"></i> Edit
                                </Dropdown.Item>
                                {row?.original?.status == 'active' && (
                                    <Dropdown.Item onClick={() => { collectionStatus(row.original.id, 'deactive') }}><i className="bi bi-x-circle"></i> deactive</Dropdown.Item>
                                )}
                                {row?.original?.status == 'deactive' && (
                                    <Dropdown.Item onClick={() => { collectionStatus(row.original.id, 'active') }}><i className="bi bi-check-circle"></i> active</Dropdown.Item>
                                )}
                                <Dropdown.Divider />
                                <Dropdown.Item as="button" type="button"
                                    className="text-danger"
                                    onClick={() => confirmDelete(row.original.id, row.original.title)}
                                >
                                    <i className="bi bi-trash"></i> Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </>
            ),
        },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowLoader(true);
                    await collectionModel.destroy(id).then((res) => {
                        reloadCollectionData();
                        helper.sweetalert.toast(`${title} deleted Successfully`);
                    });
                    setShowLoader(false);
                }
            });
    };

    return (
        <>
            <Heading title="Collections" showLoader={isLoading || showLoader}>
                {console.log()}
                <Link className="btn btn-primary btn-sm" href="/collections/create">
                    <i className="bi bi-plus" />  Create
                </Link>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Collection Lists</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={collectionData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={collectionData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};
export default Page;
